import { render, staticRenderFns } from "./warnDrawer.vue?vue&type=template&id=964b79a8&scoped=true&"
import script from "./warnDrawer.vue?vue&type=script&lang=js&"
export * from "./warnDrawer.vue?vue&type=script&lang=js&"
import style0 from "./warnDrawer.vue?vue&type=style&index=0&id=964b79a8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964b79a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('964b79a8')) {
      api.createRecord('964b79a8', component.options)
    } else {
      api.reload('964b79a8', component.options)
    }
    module.hot.accept("./warnDrawer.vue?vue&type=template&id=964b79a8&scoped=true&", function () {
      api.rerender('964b79a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/homeDrawer/drawer/warnDrawer.vue"
export default component.exports